import { render } from "./AboutUserSection.vue?vue&type=template&id=c85acb1e"
import script from "./AboutUserSection.vue?vue&type=script&lang=js"
export * from "./AboutUserSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__